import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/platform-browser';
import { RegistrationType } from './entity';

@Injectable()
export class RegistrationAnalyticService {
  private readonly regType: RegistrationType;
  private isGtagLoaded = false;
  private isClarityLoaded = false;
  private readonly GA4_ID = 'G-8MM8JB5DZ3';
  private readonly AW_ID = 'AW-16733943673';
  private componentSpecificGtagId?: string;

  constructor(
    regType: RegistrationType,
    @Inject(DOCUMENT) private document: any
  ) {
    this.regType = regType;
    this.initializeAnalytics();
  }

  setComponentSpecificGtagId(id: string): void {
    this.componentSpecificGtagId = id;
  }


  private initializeAnalytics(): void {
    this.loadGoogleAnalytics();
    this.loadClarity();
  }

  private loadGoogleAnalytics(): void {
    if (this.isGtagLoaded) return;

    // Cargar el script base de gtag.js
    const script = this.document.createElement('script');
    script.async = true;
    // Usamos el ID de GA4 como ID principal para cargar gtag.js
    script.src = `https://www.googletagmanager.com/gtag/js?id=${this.GA4_ID}`;

    const inlineScript = this.document.createElement('script');
    inlineScript.textContent = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      
      // Configurar GA4
      gtag('config', '${this.GA4_ID}');
      
      // Configurar Google Ads
      gtag('config', '${this.AW_ID}');

      // Configurar el identificador específico del componente si está definido
      ${this.componentSpecificGtagId ? `gtag('config', '${this.componentSpecificGtagId}');` : ''}
    `;


    script.onload = () => {
      this.isGtagLoaded = true;
      this.document.head.appendChild(inlineScript);
    };

    this.document.head.appendChild(script);
  }

  private loadClarity(): void {
    if (this.isClarityLoaded) return;

    const script = this.document.createElement('script');
    script.textContent = `
      (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
      })(window, document, "clarity", "script", "n47qkve4nb");
    `;

    script.onload = () => {
      this.isClarityLoaded = true;
    };

    this.document.head.appendChild(script);
  }

  public stepCompleted(stepId: number): void {
    let eventCategory: string;
    switch (this.regType) {
      case RegistrationType.PRIVATE:
        eventCategory = 'Registration Private';
        break;
      case RegistrationType.CORPORATE:
        eventCategory = 'Registration Corporate';
        break;
    }

    const eventObj = {
      event_category: eventCategory,
      event_action: 'click',
      event_label: `Completed Step ${++stepId}`
    };

    this.trackEvent('step_completed', eventObj);
  }

  private trackEvent(eventName: string, eventParams: any): void {
    if (this.isGtagLoaded) {
      const w = window as any;
      // Enviar evento a GA4
      w.gtag('event', eventName, {
        ...eventParams,
        send_to: this.GA4_ID
      });

      // Enviar evento a Google Ads si es necesario
      w.gtag('event', eventName, {
        ...eventParams,
        send_to: this.AW_ID
      });
    }

    if (this.isClarityLoaded) {
      const w = window as any;
      if (w.clarity) {
        w.clarity('event', eventName, eventParams);
      }
    }
  }





  public pageView(path: string): void {
    if (this.isGtagLoaded) {
      const w = window as any;
      // Registrar pageview en GA4
      w.gtag('config', this.GA4_ID, { page_path: path });

      // Registrar pageview en Google Ads
      w.gtag('config', this.AW_ID, { page_path: path });
    }
  }

  // Método específico para conversiones de Google Ads
  public trackConversion(conversionLabel: string, value?: number): void {
    if (this.isGtagLoaded) {
      const w = window as any;
      const eventParams: any = {
        send_to: `${this.AW_ID}/${conversionLabel}`
      };

      if (value !== undefined) {
        eventParams.value = value;
        eventParams.currency = 'EUR'; // O la moneda que corresponda
      }

      w.gtag('event', 'conversion', eventParams);

      // Agregar la conversión específica solicitada
      if (conversionLabel === 'P__7CJCZvqcaEPnurqs-') {
          w.gtag('event', 'conversion', {
              send_to: `${this.AW_ID}/P__7CJCZvqcaEPnurqs-`
          });
      }
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/clients/app/modules/+registration/api/registration-analytic.service.ts